"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderManagementRouter = {
  type: 1,
  path: '/order-management',
  component: _layout.default,
  redirect: '/order-management/order-records',
  name: '',
  meta: {
    title: 'orderManagement',
    icon: 'g-order'
  },
  children: [{
    type: 2,
    path: 'order-records',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-management/recharge-order-records'));
      });
    },
    name: 'rechargeOrder:view',
    meta: {
      title: 'orderRecords'
    },
    children: [{
      path: 'audit',
      name: 'rechargeOrder:notifyDown',
      hidden: true
    }, {
      path: 'audit',
      name: 'rechargeOrder:reacquireNotification',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'order-notify',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-management/recharge-order-notify'));
      });
    },
    name: 'rechargeOrderNotify:view',
    meta: {
      title: 'orderNotify'
    },
    children: [{
      path: 'audit',
      name: 'rechargeOrderNotify:reacquireNotification',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'refund-order-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-management/refund-order-management'));
      });
    },
    name: 'refundOrder:view',
    meta: {
      title: 'refundOrder'
    },
    children: [{
      path: 'audit',
      name: 'refundOrder:notifyDown',
      hidden: true
    }, {
      path: 'audit',
      name: 'refundOrder:reacquireNotification',
      hidden: true
    }]
  }]
};
var _default = orderManagementRouter;
exports.default = _default;